import React, { useState } from 'react';

// Translation
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { addSupplierSlice, addSupplierState } from './AddModalSlice';
import { suppliersSlice } from '../SuppliersSlice';

import { Col, Row } from 'react-grid-system';

// Components
import Modal from '../../../components/Modal/Modal';
import {
  InputField,
  Textarea,
} from '../../../components/FormElements/FormElements';
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader';

import { showSupplierSlice } from '../ShowModal/ShowModalSlice';

import { useAPI } from '../../../services/hoc/useAPI';

export default () => {
  // Translation
  const t = useTranslation();

  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { add_supplier: addSupplierState }) => state.add_supplier,
  );

const ENDPOINTS = useAPI()
  // Hooks
  const [showErrors, setShowErrors] = useState<boolean>(false);

  // Add supplier
  const add = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      !state.fields.name ||
      !state.fields.account_no ||
      !state.fields.serial_no ||
      !state.fields.phone ||
      !state.fields.mobile ||
      !state.fields.email ||
      !state.fields.government ||
      !state.fields.country ||
      !state.fields.address_1
    ) {
      setShowErrors(true);
      return;
    }

    dispatch(addSupplierSlice.actions.setIsLoading(true));
    const endpoint = state.editId
      ? ENDPOINTS.suppliers().update
      : ENDPOINTS.suppliers().store;
    endpoint({
      id: state.editId,
      ...state.fields,
    }).then((response: any) => {
      dispatch(addSupplierSlice.actions.setIsSuccess(true));
      setTimeout(() => {
        toggle();
        dispatch(suppliersSlice.actions.addSuppliers([response.data.data]));
        dispatch(
          showSupplierSlice.actions.setIsOpen({
            id: response.data.data.id,
            isOpen: true,
          }),
        );
      }, 1000);
    });
  };

  const toggle = () => {
    dispatch(addSupplierSlice.actions.setIsOpen(!state.isOpen));
    dispatch(addSupplierSlice.actions.init());
  };

  return (
    <Modal open={state.isOpen} toggle={toggle}>
      {state.isLoading ? <WhiteboxLoader /> : ''}

      {state.isSuccess ? <SuccessMark /> : ''}

      <h2 className="text-center" style={{ margin: '0 0 20px' ,color:'var(--primary-color)'}}>
        {state.editId ? t('edit_supplier') : t('add_to_suppliers')}
      </h2>

      <form onSubmit={add} style={{ width: 1200, maxWidth: '100%' }}>
        <Row>
          <Col md={6}>
            <h3>{t('personal_information')}</h3>

            <Row>
              <Col md={6}>
                <InputField
                  label={t('name') + ' *'}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({ name: e.target.value }),
                    )
                  }
                  value={state.fields.name}
                  error={
                    showErrors && !state.fields.name ? t('required_error') : ''
                  }
                />
              </Col>

              <Col md={6}>
                <InputField
                  label={t('account_number') + ' *'}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({
                        account_no: e.target.value,
                      }),
                    )
                  }
                  value={state.fields.account_no}
                  error={
                    showErrors && !state.fields.account_no
                      ? t('required_error')
                      : ''
                  }
                />
              </Col>

              <Col md={6}>
                <InputField
                  label={t('serial_number') + ' *'}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({
                        serial_no: e.target.value,
                      }),
                    )
                  }
                  value={state.fields.serial_no}
                  error={
                    showErrors && !state.fields.serial_no
                      ? t('required_error')
                      : ''
                  }
                />
              </Col>

              <Col md={6}>
                <InputField
                  label={t('phone_number') + ' *'}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({ phone: e.target.value }),
                    )
                  }
                  value={state.fields.phone}
                  error={
                    showErrors && !state.fields.phone ? t('required_error') : ''
                  }
                />
              </Col>

              <Col md={6}>
                <InputField
                  label={t('fax_number')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({ fax: e.target.value }),
                    )
                  }
                  value={state.fields.fax}
                />
              </Col>

              <Col md={6}>
                <InputField
                  label={t('telephone_number') + ' *'}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({ mobile: e.target.value }),
                    )
                  }
                  value={state.fields.mobile}
                  error={
                    showErrors && !state.fields.mobile
                      ? t('required_error')
                      : ''
                  }
                />
              </Col>

              <Col md={12}>
                <InputField
                  type="email"
                  label={t('email') + ' *'}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({ email: e.target.value }),
                    )
                  }
                  value={state.fields.email}
                  error={
                    showErrors && !state.fields.email ? t('required_error') : ''
                  }
                />
              </Col>

              <Col md={12}>
                <InputField
                  label={t('website')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({ website: e.target.value }),
                    )
                  }
                  value={state.fields.website}
                />
              </Col>
            </Row>
          </Col>

          <Col md={6}>
            <h3>{t('address')}</h3>

            <Row>
              <Col md={6}>
                <InputField
                  label={t('city')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({ city: e.target.value }),
                    )
                  }
                  value={state.fields.city}
                />

                <div className="margin-top-20" />

                <InputField
                  label={t('state_or_province') + ' *'}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({
                        government: e.target.value,
                      }),
                    )
                  }
                  value={state.fields.government}
                  error={
                    showErrors && !state.fields.government
                      ? t('required_error')
                      : ''
                  }
                />

                <div className="margin-top-20" />

                <InputField
                  label={t('country') + ' *'}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({ country: e.target.value }),
                    )
                  }
                  value={state.fields.country}
                  error={
                    showErrors && !state.fields.country
                      ? t('required_error')
                      : ''
                  }
                />

                <div className="margin-top-20" />

                <InputField
                  label={t('zip_or_postal_code')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({
                        postal_code: e.target.value,
                      }),
                    )
                  }
                  value={state.fields.postal_code}
                />

                <div className="margin-top-20" />

                <InputField
                  label={t('floor_or_house_number')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({
                        department_number: e.target.value,
                      }),
                    )
                  }
                  value={state.fields.department_number}
                />
              </Col>

              <Col md={6}>
                <Textarea
                  label={t('address_1') + ' *'}
                  rows={3}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({
                        address_1: e.target.value,
                      }),
                    )
                  }
                  value={state.fields.address_1}
                  error={
                    showErrors && !state.fields.address_1
                      ? t('required_error')
                      : ''
                  }
                />

                <div style={{ marginTop: 15.5 }} />

                <Textarea
                  label={t('address_2')}
                  rows={3}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({
                        address_2: e.target.value,
                      }),
                    )
                  }
                  value={state.fields.address_2}
                />

                <div style={{ marginTop: 15.5 }} />

                <Textarea
                  label={t('address_3')}
                  rows={3}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      addSupplierSlice.actions.set({
                        address_3: e.target.value,
                      }),
                    )
                  }
                  value={state.fields.address_3}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <button
          className="button round bg-gold color-white margin-top-30"
          style={{ padding: '0 80px', marginBottom: 5 }}>
          {t('submit')}
        </button>
      </form>
    </Modal>
  );
};
